<template>
    <div class="container is-max-desktop">
        <div class="slack-form">
            <div class="columns">
                <div class="column p-6 is-5 has-background-primary">
                    <div
                        class="has-background-primary"
                        style="border-radius: 8px; height: 100%"
                    >
                        <p
                            class="title has-text-white is-size-4"
                            v-text="$t('CATERING_ORDER_REQUEST_TITLE')"
                        />
                        <p
                            class="subtitle mt-2 has-text-white is-size-5"
                            v-text="$t('CATERING_ORDER_REQUEST_SUBTITLE')"
                        />
                    </div>
                </div>
                <div class="column p-6">
                    <LoginTextInput
                        style="margin-top: 1rem"
                        :errors="errors"
                        label="COMPANY_NAME"
                        placeholder="LABEL_COMPANY_PLACEHOLDER"
                        autocomplete="given-name"
                        name="company"
                        v-model.trim="form.company"
                    />
                    <LoginTextInput
                        style="margin-top: 1.2rem"
                        :errors="errors"
                        label="PHONE"
                        placeholder="PHONE_PLACEHOLDER"
                        autocomplete="given-name"
                        name="phone"
                        v-model.trim="form.phone"
                    />
                    <LoginTextInput
                        style="margin-top: 1.2rem"
                        :errors="errors"
                        label="LABEL_EMAIL"
                        placeholder="PLACEHOLDER_EMAIL_SAMPLE"
                        autocomplete="given-name"
                        name="email"
                        v-model.trim="form.email"
                    />
                    <PreLoginButton
                        :label="$t('BUTTON_SEND')"
                        :loading="loading"
                        @click="submit"
                        class="login-form-button"
                    />
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import LoginTextInput from '@/views/PreLoginView/LoginTextInput.vue'
import PreLoginButton from '@/views/PreLoginView/PreLoginButton.vue'
export default {
    components: { LoginTextInput, PreLoginButton },
    data() {
        return {
            errors: new this.$Errors(),
            loading: false,
            form: {
                phone: '',
                company: '',
                email: ''
            }
        }
    },
    methods: {
        submit() {
            if (this.loading) {
                return
            }
            this.loading = true
            const { company, phone, email } = this.form
            Object.entries(this.form).forEach(([key, value]) => {
                if (!value) {
                    this.errors.set(key)
                }
                if (key == 'email' && !this.$Utils.validateMail(value)) {
                    this.errors.set(key, this.$t('INVALID_EMAIL_FORMAT'))
                }
            })
            if (this.errors.errors.length > 0) {
                this.loading = false
                return
            }
            this.$Analytics
                .sendCateringRequest({ company, phone, email })
                .then(() => {
                    this.$router.push('/status/catering_request_successful')
                })
                .catch(() => this.$Network.handleError)
                .then(() => {
                    this.loading = false
                })
        }
    }
}
</script>
<style lang="scss" scoped>
.slack-form {
    border: $primary 2px solid;
    background: $white;
    border-radius: 8px;
    overflow: hidden;
    margin-top: 1rem;

    @media (max-width: $tablet) {
        border-radius: 0;
        border: none;
        margin-top: 0;
    }
}
</style>
